import { ActionReducer, MetaReducer, INIT, UPDATE } from '@ngrx/store';
import * as userActions from '../actions/user.action';

export const STORAGE_KEY = 'card4games_shop_state';

/**
 * Meta-reducer that persists specified slices of NgRx store state into localStorage
 * and rehydrates them when the application initializes.
 *
 * Safe for Angular SSR (Server-Side Rendering).
 */
export function localStorageSyncMetaReducer<T = any>(
  storageKey: string = STORAGE_KEY,
  keysToPersist: string[] = ['cartModule', 'userModule', 'regionalSetting', 'walletModule']
): MetaReducer<T> {
  return (reducer: ActionReducer<T>): ActionReducer<T> => {
    let isInitial = true;
    let isLoggedOut = false;

    return (state: T | undefined, action: any): T => {
      let nextState = reducer(state, action);

      // SSR Safety Check: Ensure window & localStorage exist before proceeding
      if (typeof window === 'undefined' || !window.localStorage) {
        return nextState;
      }

      // Rehydrate state from localStorage on startup / initialization
      if (isInitial || action?.type === INIT || action?.type === UPDATE) {
        isInitial = false;
        isLoggedOut = false;
        try {
          const storedState = localStorage.getItem(storageKey);
          if (storedState) {
            const parsedState = JSON.parse(storedState);
            nextState = {
              ...nextState,
              ...parsedState,
            };
          }
        } catch (error) {
          console.error('[localStorageSyncMetaReducer] Error rehydrating state:', error);
        }
      }

      // Clear localStorage on logout and block all future saves until reinitialization
      if (action?.type === userActions.LOGOUT.type) {
        localStorage.removeItem(storageKey);
        isLoggedOut = true;
        return nextState;
      }

      // Skip saving if user has logged out
      if (isLoggedOut) {
        return nextState;
      }

      // Save configured state keys to localStorage on state changes
      try {
        if (nextState) {
          const stateToSave: Record<string, any> = {};
          const keys =
            keysToPersist && keysToPersist.length > 0
              ? keysToPersist
              : Object.keys(nextState as object);

          keys.forEach((key) => {
            if ((nextState as any)[key] !== undefined) {
              stateToSave[key] = (nextState as any)[key];
            }
          });

          localStorage.setItem(storageKey, JSON.stringify(stateToSave));
        }
      } catch (error) {
        console.error('[localStorageSyncMetaReducer] Error saving state:', error);
      }

      return nextState;
    };
  };
}

export const metaReducers: MetaReducer<any>[] = [
  localStorageSyncMetaReducer(STORAGE_KEY, [
    // 'cartModule',
    // 'userModule',
    'regionalSetting',
    'cart'
    // 'walletModule',
  ]),
];
